<div *ngIf="createForm">
  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 8">
    <div class="row">
      <div class="col-md-11">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 8">
              {{ getIntitule(indexPage) | translate }}
            </legend>
            <app-step1
              *ngIf="indexPage === 1"
              [parentForm]="form"
              [attributionFromMAPA]="ann.mapa.attributionFromMAPA"
              [disabled]="disabled"
              [uid]="getUid(1)"
              [linkForRouter]="linkForRouter"
            >
            </app-step1>

            <app-step1common
              *ngIf="indexPage === 2"
              [parentForm]="form"
              [mapa]="ann.mapa"
              [disabled]="disabled"
              [uid]="getUidCommon(2)"
              [linkForRouter]="linkForRouter"
            >
            </app-step1common>

            <app-step2
              *ngIf="indexPage === 3"
              [parentForm]="form"
              [attributionFromMAPA]="ann.mapa.attributionFromMAPA"
              [disabled]="disabled"
              [uid]="getUid(3)"
              [linkForRouter]="linkForRouter"
            >
            </app-step2>

            <app-step3
              *ngIf="indexPage === 4"
              [parentForm]="form"
              [criteresAttribution]="
                ann.mapa.attributionFromMAPA.criteresAttribution
              "
              [disabled]="disabled"
              [uid]="getUid(4)"
              [linkForRouter]="linkForRouter"
            ></app-step3>

            <app-step4
              *ngIf="indexPage === 5"
              [parentForm]="form"
              [attribue]="
                ann?.mapa?.attributionFromMAPA?.attribution?.resultat?.attribue
              "
              [disabled]="disabled"
              [uid]="getUid(5)"
              [linkForRouter]="linkForRouter"
            >
            </app-step4>

            <app-step5
              *ngIf="indexPage === 6"
              [parentForm]="form"
              [attribution]="ann.mapa.attributionFromMAPA.attribution"
              [disabled]="disabled"
              [uid]="getUid(6)"
              [linkForRouter]="linkForRouter"
            ></app-step5>

            <app-step6
              *ngIf="indexPage === 7"
              [parentForm]="form"
              [attributionFromMAPA]="ann.mapa.attributionFromMAPA"
              [disabled]="disabled"
              [uid]="getUid(7)"
              [linkForRouter]="linkForRouter"
            >
            </app-step6>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
